import { Component, signal } from '@angular/core';
import { DocMeta } from "@template-ui/decorators";
import { UiLibraryModule } from "@template-ui/template-ui.module";
import { PanelHeaderConfig, ResponsiveButtonGroupConfig } from "@template-ui/types";


@DocMeta({
  hide: true,
  showcaseTitle: "Panel header with a button, reactive title and legend",
  showcaseDesc: `
  This sample demonstrates:
  - Using the panelHeaderConfig input to configure the component
  - Using the additionalActions property of the config object to create a button on the right
  - The use of a reactive input in a config object.
  - Legend Items are used to specify a label and class. The class is defined in the scss file.

  The panelHeaderTitle is defined as a \`\`\`StringReactiveInput\`\`\`. By setting it to the signal \`\`\`this.panelTitleSig\`\`\`,
  this method allows changing of the config object property in the parent component without the need to get a reference to
  the component itself.

  To see it work, click the 'Toggle Title' button and see the title change. Note that nothing references the ez-panel-header
  directly, only the property on the config object is modified.
  `
})
@Component({
    selector: 'ui-panel-header-with-reactive-title, ez-panel-header-with-reactive-title',
    imports: [UiLibraryModule],
    templateUrl: './PanelHeaderWithReactiveTitle.component.html',
    styleUrl: './PanelHeaderWithReactiveTitle.component.scss'
})
export class PanelHeaderWithReactiveTitleComponent
{

  readonly originalTitle = "I came from the config object";
  panelTitleSig = signal<string>(this.originalTitle);

  legendItems = [
    {className: 'warning', label: 'Warning' }
  ]

  panelHeaderConfig: PanelHeaderConfig = {
    panelHeaderTitle: this.panelTitleSig,
    additionalActions: {
      buttonsConfig: [
        {
          buttonText: "Toggle Title",
          onClick: (but, event) => {
            this.panelTitleSig
            .set(this.panelTitleSig() == this.originalTitle ?
                                    "I was set by a reactive input on the config object"
                                    : this.originalTitle)

          },
        }
      ]
    } as ResponsiveButtonGroupConfig
  }
}


